// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-EWnU","left":"styles_left__P7r30"};